<template>
  <div class="ttshop_details">
    <Header></Header>
    <Singinheader :headertext="text"></Singinheader>
    <div class="ttshop_detailscon">
      <div class="ttshop_detailsup clearfloat">
        <input
          type="text"
          placeholder="请输入问题的关键词"
          @keyup.enter="searchArticle"
          v-model="keyword"
        />
        <button @click="searchArticle">搜索</button>
      </div>
      <!-- <h5>{{ttshop_details.title}}</h5> -->
    </div>
    <div class="ttshop_detailsconter">
      <div class="ttshop_detailscontered w">
        <div class="ttshop_detailstext clearfloat d-flex">
          <div class="ttshop_detaileft">
            <h5>
              <i
                ><img
                  class="img-default"
                  src="../../assets/images/ttshop_deatil.png"
                  alt="" /></i
              >问题分类
            </h5>
            <el-tree
              :data="cat_list"
              :props="{ children: 'child', label: 'name' }"
              :highlight-current="true"
              accordion
              @node-click="catChange"
              node-key="id"
              :default-expanded-keys="[cat_id]"
              :default-checked-keys="[cat_id]"
            ></el-tree>
          </div>
          <div class="ttshop_detailright">
            <template v-if="article_id">
              <h5 v-text="article.title"></h5>
              <div class="ttshop_detailrightcon" v-html="article.content"></div>
            </template>
            <div class="catalog-list" v-else>
              <ul v-if="catalog && catalog.length">
                <template v-for="(item, index) in catalog">
                  <li
                    class="show-one-lines"
                    v-text="item.title"
                    @click="catalogChange(item.id)"
                  ></li>
                </template>
              </ul>
              <template v-else>
                <div v-if="data_type">暂无相关内容</div>
              </template>

              <div class="bottom_right_corner" v-if="catalog && catalog.length">
                <el-pagination
                  :hide-on-single-page="true"
                  :page-size="20"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page.sync="page"
                  layout="prev, pager, next"
                  :total="cataRow"
                >
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Singinheader from "./components/singinheader";
import Foot from "@/components/foot/foot";

export default {
  components: {
    Header,
    Singinheader,
    Foot,
  },
  data() {
    return {
      text: "帮助中心",
      data_type: false,
      cat_list: [], //分类列表
      catalog: [], //文章列表
      article: {}, //文章详情
      keyword: this.$route.query.keyword || "", //搜索关键字
      article_id: this.$route.query.article_id || 0, //文章id
      cat_id: this.$route.query.cat_id || 0, //分类id
      cataRow: 0, //文章总条数
      cataTal: 0, //文章总页数
      page: 1,
    };
  },
  created() {
    this.articleList();
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      if (
        to.query.cat_id != from.query.cat_id ||
        to.query.article_id != from.query.article_id ||
        to.query.keyword != from.query.keyword
      ) {
        this.keyword = to.query.keyword;
        this.cat_id = to.query.cat_id;
        this.article_id = to.query.article_id;
        this.articleList();
      }
    },
  },
  methods: {
    handleChange(val) {
      console.log(val);
    },
    // 获取文章内容
    articleList() {
      let params = {
        article_id: this.article_id,
        cat_id: this.cat_id,
        keyword: this.keyword,
		    page:this.page,
      };
      this.data_type = false;
      this.$api
        .articleList(params)
        .then((res) => {
          this.data_type = true;
          this.article = res.data.article;
          if (!this.cat_list.length) {
            this.cat_list = res.data.cat;
          }
          this.catalog = res.data.catalog;
          this.cataTal = res.data.page_count;
          this.cataRow = Number(res.data.row_count);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 点击分类
    catChange(data) {
      this.page=1;
      this.$router.push({
        path: "/ttshop_details",
        query: {
          cat_id: data.id,
        },
      });
    },
    // 点击文章
    catalogChange(id) {
      this.$router.push({
        path: "/ttshop_details",
        query: {
          article_id: id,
        },
      });
    },
    // 搜索关键字
    searchArticle() {
      this.catalog = [];
      this.page=1;
      this.$router.push({
        path: "/ttshop_details",
        query: {
          keyword: this.keyword,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.ttshop_details {
  width: 100%;

  .ttshop_detailscon {
    width: 100%;
    height: 120px;
    line-height: 120px;
    background: linear-gradient(180deg, #ffd7d7, #f2e5e5);
    background: -moz-linear-gradient(180deg, #ffd7d7, #f2e5e5);
    background: -webkit-gradient(180deg, #ffd7d7, #f2e5e5);
    background: -ms-linear-gradient(180deg, #ffd7d7, #f2e5e5);
    filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#FFD7D7, endColorstr=#F2E5E5);

    .ttshop_detailsup {
      width: 790px;
      margin: 0 auto;
      padding-top: 35px;
      box-sizing: border-box;

      input {
        float: left;
        width: 690px;
        height: 50px;
        border: 2px solid #ff1923;
        padding: 0 15px;
        box-sizing: border-box;
        outline: none;
        font-size: 16px;
        color: #333;
        background: #fff;
        border-right: 0;
        border-radius: 4px 0 0 4px;
      }

      button {
        float: left;
        width: 100px;
        height: 50px;
        background: linear-gradient(90deg, #ff9010, #ff0e25);
        background: -moz-linear-gradient(90deg, #ff9010, #ff0e25);
        background: -webkit-gradient(90deg, #ff9010, #ff0e25);
        background: -ms-linear-gradient(90deg, #ff9010, #ff0e25);
        filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#FF9010, endColorstr=#FF0E25);
        outline: none;
        font-size: 16px;
        color: #fff;
        border: 0;
        border-radius: 0 4px 4px 0;
        cursor: pointer;
      }
    }

    h5 {
      font-size: 24px;
      color: #333;
      font-weight: 500;
      text-align: center;
    }
  }

  .ttshop_detailsconter {
    width: 100%;
    padding: 20px 0 50px 0;
    box-sizing: border-box;
    background: #f2f2f2;

    .ttshop_detailstext {
      width: 100%;

      .ttshop_detaileft {
        float: left;
        width: 190px;
        background: #fff;
        margin-right: 10px;

        h5 {
          width: 100%;
          height: 50px;
          background: #ff0e25;
          font-size: 16px;
          color: #fff;
          font-weight: 500;
          line-height: 50px;
          padding-left: 18px;
          box-sizing: border-box;

          i {
            display: inline-block;
            width: 16px;
            height: 16px;
            margin-right: 6px;
            vertical-align: -1px;

            img {
              display: block;
            }
          }
        }
        // 修改分类默认样式
        .el-tree {
          > .el-tree-node {
            > .el-tree-node__content:first-child {
              // background: #F2F2F2 !important;
              border-top: 1px solid #f9f9f9;

              > .el-tree-node__label {
                color: #333 !important;
              }
            }
          }
        }
        // 选中状态
        .el-tree-node.is-current {
          > .el-tree-node__content:first-child {
            > .el-tree-node__label {
              color: #ff0e25 !important;
            }
          }
        }
        .el-tree-node__content {
          cursor: pointer;
          height: 44px;
          box-sizing: border-box;
          background: transparent !important;
        }
        .el-tree-node__content:hover {
          .el-tree-node__label {
            color: #ff0e25;
          }
        }
        .el-tree-node__label {
          font-size: 13px;
        }

        .ttshop_detalist {
          font-size: 12px;
          color: #999;
          width: 100%;
          height: 28px;
          padding: 0 20px 0 30px;
          box-sizing: border-box;
          line-height: 28px;
          cursor: pointer;
          transition: 0.5s;
          -moz-transition: 0.5s;
          -webkit-transition: 0.5s;
          -o-transition: 0.5s;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &.active {
            color: #ff0e25;
          }
          &:hover {
            color: #ff0e25;
          }
        }
      }
      .ttshop_detailright {
        float: left;
        width: 988px;
        background: #fff;
        padding: 26px 30px 35px 30px;
        box-sizing: border-box;
        h5 {
          font-size: 18px;
          color: #333;
          font-weight: 500;
          padding-bottom: 20px;
          box-sizing: border-box;
          border-bottom: 1px solid #d8d8d8;
        }
        .catalog-list {
          ul {
            li {
              line-height: 22px;
              color: #666;
              cursor: pointer;
              transition: color 0.3s;
            }
            li:before {
              content: "·";
              display: inline-block;
              padding-right: 5px;
            }
            li:hover {
              color: #ff0e25;
            }
          }
          div {
            color: #666;
            font-size: 14px;
            line-height: 60px;
            text-align: center;
          }
        }
        .ttshop_detailrightcon {
          width: 100%;
          padding-top: 23px;
          box-sizing: border-box;
          p {
            font-size: 14px;
            color: #666;
            line-height: 22px;
            font-weight: 400;
          }
        }
      }
    }
  }
  .bottom_right_corner {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .el-pagination {
      ul {
        li:before {
          content: "" !important;
          display: inline-block;
          padding-right: 0 !important;
        }
      }
    }
  }
}
</style>
